export const todayStr = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Amsterdam' });

export const addDays = (d, n) => {
  const x = new Date(`${d}T12:00:00`);
  x.setDate(x.getDate() + n);
  return x.toLocaleDateString('sv-SE');
};

export const dayLabel = (d) => {
  if (!d) return '';
  const t = todayStr();
  if (d <= t) return 'Vandaag';
  if (d === addDays(t, 1)) return 'Morgen';
  return new Date(`${d}T12:00:00`).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
};
